require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-artist-profile-kennan-mendis-aka-kenzopaints.json") })
        }
      }, "path---news-artist-profile-kennan-mendis-aka-kenzopaints");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-artist-profile-kennan-mendis-aka-kenzopaints!./.cache/json/news-artist-profile-kennan-mendis-aka-kenzopaints.json
// module id = 792
// module chunks = 231608221292675